import BaseSingle from "../../../engines/libs/BaseSingle";
import DebugData from "./debug/DebugData";
import MansionDataManage from "./mansion/MansionDataManage";
import MatchMiaiDataManage from "./matchMiai/MatchMiaiDataManage";
import MilitaryCityDataManage from "./military/city/MilitaryCityDataManage";
import MilitaryOfficerDataManage from "./military/officer/MilitaryOfficerDataManage";
import ShipDataManage from "./ship/ShipDataManage";
import ThruTimeDataManage from "./thruTime/ThruTimeDataManage";


export default class UserDataManage extends BaseSingle{
    static get instance() {
        return super.GetInstance<UserDataManage>();
    }
    constructor() {
        super();
        this.resetInit();
    }

    debugData: DebugData = null;
    militaryOfficerDataManage: MilitaryOfficerDataManage = null;
    militaryCityDataManage: MilitaryCityDataManage = null;
    matchMiaiDataManage: MatchMiaiDataManage = null;
    mansionDataManage: MansionDataManage = null;
    thruTimeDataManage: ThruTimeDataManage = null;
    shipDataManage: ShipDataManage = null;
    
    anewStart() {
        this.resetInit();
        this.militaryOfficerDataManage.saveAllLocationData();
        this.militaryCityDataManage.saveAllLocationData();
        this.matchMiaiDataManage.saveAllLocationData();
        this.mansionDataManage.saveAllLocationData();
        this.thruTimeDataManage.saveAllLocationData();
        this.shipDataManage.saveAllLocationData();
    }

    resetInit() {
        this.militaryOfficerDataManage = new MilitaryOfficerDataManage();
        this.militaryCityDataManage = new MilitaryCityDataManage();
        this.matchMiaiDataManage = new MatchMiaiDataManage();
        this.mansionDataManage = new MansionDataManage();
        this.debugData = new DebugData();
        this.thruTimeDataManage = new ThruTimeDataManage();
        this.shipDataManage = new ShipDataManage();
    }

    loadLocationData() {
        this.militaryOfficerDataManage.loadLocationData();
        this.militaryCityDataManage.loadLocationData();
        this.matchMiaiDataManage.loadLocationData();
        this.mansionDataManage.loadLocationData();
        this.thruTimeDataManage.loadLocationData();
        this.shipDataManage.loadLocationData();
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {
        this.militaryOfficerDataManage.dayDataDispose();
        this.militaryCityDataManage.dayDataDispose();
        this.matchMiaiDataManage.dayDataDispose();
        this.mansionDataManage.dayDataDispose();
        this.thruTimeDataManage.dayDataDispose();
        this.shipDataManage.dayDataDispose();
    }

}